export const SERVICE = 'DRAFT'
